import { createContext, useContext } from "react";

// Provides a function to open the "Book a Demo" modal from anywhere.
export const DemoContext = createContext(() => {});
export const useDemo = () => useContext(DemoContext);
